import { ShiftAuthRequestError } from '../../services/auth/shift-auth.service';
import type { ShiftVacationStatus } from '../../models/vacations.types';

export const STATUS_LABELS: Record<ShiftVacationStatus, string> = {
  pending: 'ממתינה לאישור',
  approved: 'אושרה',
  rejected: 'נדחתה',
  cancelled: 'מבוטלת',
  occurred: 'התקיימה',
};

export const formatDate = (value: string) => {
  const [year, month, day] = value.split('-');
  return `${day}.${month}.${year}`;
};

export const messageFromError = (error: unknown, fallback: string) =>
  error instanceof ShiftAuthRequestError ? error.message || fallback : fallback;
